import React, { useState, useEffect } from 'react';
import { FiCalendar } from 'react-icons/fi';

const AgeVerification: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [day, setDay] = useState('');
  const [month, setMonth] = useState('');
  const [year, setYear] = useState('');

  useEffect(() => {
    const ageVerified = localStorage.getItem('ageVerified');
    if (!ageVerified) {
      setIsVisible(true);
    }
  }, []);

  const handleVerify = () => {
    const birthDate = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
    const today = new Date();
    const age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    const actualAge = monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())
      ? age - 1
      : age;

    if (actualAge >= 18) {
      localStorage.setItem('ageVerified', 'true');
      setIsVisible(false);
    } else {
      alert('Vous devez avoir au moins 18 ans pour accéder à ce site.');
    }
  };

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 z-[100] bg-black/90 flex items-center justify-center p-4">
      <div className="bg-dark-card border border-dark-border rounded-lg shadow-2xl p-8 max-w-md w-full animate-fade-in">
        <div className="text-center mb-6">
          <FiCalendar className="mx-auto mb-4 text-accent-primary" size={48} />
          <h2 className="text-white font-bold text-2xl mb-2">Vérification de l'âge</h2>
          <p className="text-dark-muted text-sm">
            Vous devez avoir au moins 18 ans pour accéder à ce site.
          </p>
        </div>

        <div className="space-y-4 mb-6">
          <div>
            <label className="block text-white text-sm font-semibold mb-2">
              Date de naissance
            </label>
            <div className="grid grid-cols-3 gap-3">
              <select
                value={day}
                onChange={(e) => setDay(e.target.value)}
                className="bg-dark-surface border border-dark-border rounded-lg px-4 py-3 text-white focus:outline-none focus:ring-2 focus:ring-accent-primary"
              >
                <option value="">Jour</option>
                {Array.from({ length: 31 }, (_, i) => i + 1).map((d) => (
                  <option key={d} value={d}>
                    {d}
                  </option>
                ))}
              </select>
              <select
                value={month}
                onChange={(e) => setMonth(e.target.value)}
                className="bg-dark-surface border border-dark-border rounded-lg px-4 py-3 text-white focus:outline-none focus:ring-2 focus:ring-accent-primary"
              >
                <option value="">Mois</option>
                {Array.from({ length: 12 }, (_, i) => i + 1).map((m) => (
                  <option key={m} value={m}>
                    {m}
                  </option>
                ))}
              </select>
              <select
                value={year}
                onChange={(e) => setYear(e.target.value)}
                className="bg-dark-surface border border-dark-border rounded-lg px-4 py-3 text-white focus:outline-none focus:ring-2 focus:ring-accent-primary"
              >
                <option value="">Année</option>
                {Array.from({ length: 100 }, (_, i) => new Date().getFullYear() - i).map(
                  (y) => (
                    <option key={y} value={y}>
                      {y}
                    </option>
                  )
                )}
              </select>
            </div>
          </div>
        </div>

        <button
          onClick={handleVerify}
          disabled={!day || !month || !year}
          className="w-full bg-accent-primary hover:bg-accent-primary/90 disabled:opacity-50 disabled:cursor-not-allowed text-white font-semibold py-3 px-6 rounded-lg transition-colors"
        >
          Vérifier mon âge
        </button>

        <p className="text-dark-muted text-xs text-center mt-4">
          En continuant, vous confirmez que vous avez l'âge légal requis.
        </p>
      </div>
    </div>
  );
};

export default AgeVerification;

